export const SaleLotModalTypes = {
  EXTERNAL_AGENT_SALE: "external-agent",
};
